import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse, UserInfo } from '@core/models';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, throwError } from 'rxjs';
import { catchError, publishReplay, refCount, retry, take } from 'rxjs/operators';
import { environment } from '@env';
import { AnonymousRequestHeaderOptions, ApiEndpoints } from '@core/constants';

@Injectable({
  providedIn: 'root'
})
export class NewuserService {


  constructor(private httpClient: HttpClient, private toastr: ToastrService) {
  }

  private apiUrl = environment.apiHost;
  private readonly lookupMetadata = ApiEndpoints.lookupMetadata;
  private readonly getApplication = ApiEndpoints.getApplicationList;
  private readonly getUserApplication = ApiEndpoints.userApplications;
  private readonly getUserNotifications = ApiEndpoints.userNotifications;
  private readonly getRoles = ApiEndpoints.getRoleList;
  private readonly getApplicationRoles = ApiEndpoints.getApplicationRoles;
  private readonly getApplicationAndGenericRoles = ApiEndpoints.getApplicationAndGenericRoles;
  private readonly countries = ApiEndpoints.getAllCountries;
  private readonly userName = ApiEndpoints.verifyUserName;
  private readonly apiEmail = ApiEndpoints.verifyEmail;
  private readonly apiVerifyEmailDelete = ApiEndpoints.verifyEmailDelete;
  private readonly timeZone = ApiEndpoints.getAllTimezones;
  private readonly organization = ApiEndpoints.getAllOrganizations;
  private readonly userRegister = ApiEndpoints.userRegister;
  private readonly findUser = ApiEndpoints.findUser;
  private readonly getUser = ApiEndpoints.getUserInfo;
  private readonly getSupplierType = ApiEndpoints.getSupplierType;
  private readonly getNationalUsers = ApiEndpoints.getNationalStaff;
  private readonly fieldValidation = ApiEndpoints.fieldValidation;
  private readonly deleteUser = ApiEndpoints.deleteUser;
  private readonly updateuserEmailId = ApiEndpoints.updateUserEmailId

  // Bulk Registration
  private readonly bulkUser = ApiEndpoints.bulkUserRegistration;
  private readonly userRegistrationBulk = ApiEndpoints.userRegistrationBulk;

  // Application Management
  private readonly appCreation = ApiEndpoints.appCreation;
  private readonly updateApp = ApiEndpoints.appUpdate;
  private readonly deleteApp = ApiEndpoints.deleteApp;
  private readonly roleNameValidate = ApiEndpoints.roleNameValidation;

  // RoleMangement -> Generic Roles
  private readonly roleCreation = ApiEndpoints.roleCreation;
  private readonly roleUpdate = ApiEndpoints.roleUpdate;
  private readonly roleDelete = ApiEndpoints.roleDelete;

  // MemberProfiles -> Change Password
  private readonly changePassword = ApiEndpoints.changePassword;

  // MemberProfiles -> Generic Roles
  private readonly userRoleAssign = ApiEndpoints.userRoleAssign;
  private readonly getUserGenericRoles = ApiEndpoints.getUserAssignedGenericRoles;

  // MemberProfiles -> Application and Roles
  private readonly userAppRoleMap = ApiEndpoints.userAppRoleMapping;
  private readonly getUserAppRoleMap = ApiEndpoints.getUserAppRoleMapping;
  private readonly appRoleDelete = ApiEndpoints.appRoleDeleteEntry;

  // RoleManagement -> Application and Roles
  private readonly posAppRoleMap = ApiEndpoints.posAppRoleMapping;
  private readonly getPosAppRoleMap = ApiEndpoints.getPosAppRoleMapping;
  private readonly deletePosAppRoleMap = ApiEndpoints.deletePosAppRoleMapping;

  // RoleManagement -> Generic Role Mapping
  private readonly genericRoleMap = ApiEndpoints.genericRoleMapping;
  private readonly getGenericRoleMap = ApiEndpoints.getGenericRoleMapping;
  private readonly deleteGenericRoleMap = ApiEndpoints.deleteGenericRoleMapping;

  private readonly apiClubStateCountry = ApiEndpoints.getClubStateCountry;
  private readonly userInfo = ApiEndpoints.getUserInfo;
  private readonly putUserInfo = ApiEndpoints.putUserInfo;
  private readonly changeOrg = ApiEndpoints.changeOrganizations;
  private readonly deleteOrg = ApiEndpoints.deleteOrganization;
  private readonly getManagersForOrg = ApiEndpoints.getManagersForOrg;

  private _jsonURL = 'assets/json/countries.json';
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Anonymous': 'yes' })
  };


  deleteOptions: any;

  url: any;

  GetLookupMetadataCollection(): Observable<any> {
    return this.httpClient.get(this.lookupMetadata, AnonymousRequestHeaderOptions);
  }

  GetApplication(): Observable<any> {
    return this.httpClient.get(this.getApplication);
  }

  GetRoles(): Observable<any> {
    return this.httpClient.get(this.getRoles);
  }

  GetApplicationRoles(): Observable<any> {
    return this.httpClient.get(this.getApplicationRoles);
  }

  GetApplicationAndGenericRoles(): Observable<any> {
    return this.httpClient.get(this.getApplicationAndGenericRoles);
  }

  getUserInfo(userID: any): Observable<UserInfo> {
    const url = this.userInfo + `${userID}`;

    return this.httpClient.get<UserInfo>(this.userInfo + `${userID}`)
      .pipe(
        catchError(this.handleError<UserInfo>('getUserInfo', null))
      );
  }

  getSupplierVerficationType(organizationID: any): Observable<any> {
    const url = this.getSupplierType + `${organizationID}`;
    return this.httpClient.get(url)
      .pipe(
        catchError(this.handleError<ApiResponse>('getSupplierVerficationType', null))
      );
  }

  updateUserInfo(userInfo: any): Observable<ApiResponse> {
    return this.httpClient.put<ApiResponse>(this.putUserInfo, userInfo, this.httpOptions)
      .pipe(
        catchError(this.handleError<ApiResponse>('updateUserInfo', null))
      );
  }

  sendVerificationEmail(emailID: any, VerificationCode: any, DisplayName: any): Observable<any> {
    return this.httpClient.get<any>(this.apiEmail + `${emailID}/?VerificationCode=${VerificationCode}&DisplayName=${DisplayName}`, AnonymousRequestHeaderOptions)
  }
  CodeVerification(emailID: any, VerificationCode: any, DisplayName: any): Observable<any> {
    return this.httpClient.get<any>(this.apiEmail + `${emailID}/?VerificationCode=${VerificationCode}&DisplayName=${DisplayName}`, AnonymousRequestHeaderOptions)
  }
  
  sendVerificationEmail_Delete(emailID: any, VerificationCode: any, DisplayName: any): Observable<any> {
    return this.httpClient.get<any>(this.apiVerifyEmailDelete + `${emailID}/?VerificationCode=${VerificationCode}&DisplayName=${DisplayName}`, AnonymousRequestHeaderOptions)
  }
  CodeVerification_Delete(emailID: any, VerificationCode: any, DisplayName: any): Observable<any> {
    return this.httpClient.get<any>(this.apiVerifyEmailDelete + `${emailID}/?VerificationCode=${VerificationCode}&DisplayName=${DisplayName}`, AnonymousRequestHeaderOptions)
  }

  updateuserEmail(emailId: string, userId: string): Observable<any> {
    return this.httpClient.get<any>(this.updateuserEmailId + `${emailId}` + '/' + `${userId}`)
  }

  userNameVerification(userName: string): Observable<any> {
    return this.httpClient.get<any>(this.userName + `${userName}`, AnonymousRequestHeaderOptions)
  }

  getCountries(): Observable<any> {
    return this.httpClient.get(this.countries, AnonymousRequestHeaderOptions);
  }
  getOrganization(): Observable<any> {
    return this.httpClient.get(this.organization, AnonymousRequestHeaderOptions).pipe(
      publishReplay(1), // publishReplay(1, _time_)
      refCount(),
      take(1),
    );;
  }

  getClubStateCountry(globalID: any): Observable<any> {
    return this.httpClient.get<any>(this.apiClubStateCountry + `${globalID}`, AnonymousRequestHeaderOptions)
  }

  getFieldValidation(fieldName: any, fieldValue: any): Observable<any> {
    return this.httpClient.get<any>(this.fieldValidation + `${fieldName}` + '/' + `${fieldValue}`)
      .pipe(
        catchError(this.handleError<any>('getFieldValidation', null))
      );
  }

  GettimeZone(): Observable<any> {
    return this.httpClient.get(this.timeZone, AnonymousRequestHeaderOptions);
  }

  GetManagersForOrg(orgData: any): Observable<any> {
    return this.httpClient.post<any>(this.getManagersForOrg, orgData)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('GetManagersData', null))
      );
  }

  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.log('Service Error :', error);
      //  console.error("Service Error :", error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  registerUser(userInfo: any): Observable<any> {
    return this.httpClient.post<any>(this.userRegister, userInfo, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError())
      );
  }

  findUserInfo(userInfo: any): Observable<any> {
    return this.httpClient.post<any>(this.findUser, userInfo, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError())
      );
  }

  bulkUserRegistration(bulkUserFile: any): Observable<any> {
    return this.httpClient.post<any>(this.bulkUser, bulkUserFile, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError())
      );
  }

  UserRegistrationBulk(data: any): Observable<any> {
    console.log(data);
    return this.httpClient.post<any>(this.userRegistrationBulk, data, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError(''))
      );
  }


  deleteUserAccount() {
    return this.httpClient.delete<any>(this.deleteUser, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('deleteUser', null))
      );
  }

  // Application Management starts***********

  applicationCreation(appInfo: any): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(this.appCreation, appInfo)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('applicationCreation', null))
      );
  }

  applicationUpdate(appInfo: any): Observable<ApiResponse> {
    return this.httpClient.put<ApiResponse>(this.updateApp, appInfo)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('applicationUpdate', null))
      );
  }

  deleteApplication(ApplicationId: any) {
    return this.httpClient.delete<any>(this.deleteApp + `${ApplicationId}`, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('deleteApplication', null))
      );
  }

  getUserApplications(userID: any): Observable<any> {
    return this.httpClient.get<any>(this.getUserApplication + `${userID}`)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('getUserApplications', null))
      );
  }

  getNotifications(userID: any): Observable<any> {
    return this.httpClient.get<any>(this.getUserNotifications + '/' + `${userID}`)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('getNotificaitons', null))
      );
  }


  roleNameValidation(GroupName: any) {
    return this.httpClient.get<any>(this.roleNameValidate + `${GroupName}`, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('roleNameValidation', null))
      );
  }


  // RoleManagement starts***********

  // Application and Roles start
  positionsMapApplicationWithRoles(positionsMapApplicationWithRoles: any): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(this.posAppRoleMap, positionsMapApplicationWithRoles)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('positionsMapApplicationWithRoles', null))
      );
  }

  deletePositionsMapAppWithRoles(applicationRoleData: any) {
    return this.httpClient.post<any>(this.deletePosAppRoleMap, applicationRoleData)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('deletePositionsMapAppWithRoles', null))
      );
  }

  getPosAppRoleMapping(): Observable<any> {
    return this.httpClient.get<any>(this.getPosAppRoleMap)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('getPosAppRoleMapping', null))
      );
  }

  // Generic Role Mapping start
  genericRoleMapping(genericRoleMapping: any): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(this.genericRoleMap, genericRoleMapping)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('genericRoleMapping', null))
      );
  }

  updateGenericRoleMapping(genericRoleMapping: any): Observable<ApiResponse> {
    return this.httpClient.put<ApiResponse>(this.genericRoleMap, genericRoleMapping)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('updateGenericRoleMapping', null))
      );
  }

  deleteGenericRoleMapping(genericRoleData: any) {
    return this.httpClient.post<any>(this.deleteGenericRoleMap, genericRoleData)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('deleteGenericRoleMapping', null))
      );
  }

  getGenericRoleMapping(): Observable<any> {
    return this.httpClient.get<any>(this.getGenericRoleMap)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('getGenericRoleMapping', null))
      );
  }

  // Generic Roles start

  // Post for Generic Roles
  rolesCreation(roleInfo: any): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(this.roleCreation, roleInfo, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('rolesCreation', null))
      );
  }

  // Put for Generic Roles
  updateRole(roleInfo: any): Observable<ApiResponse> {
    return this.httpClient.put<ApiResponse>(this.roleUpdate, roleInfo, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('updateRole', null))
      );
  }

  // Delete for Generic Roles
  deleteRole(roleid: any) {
    return this.httpClient.delete<any>(this.roleDelete + `${roleid}`, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('deleteRole', null))
      );
  }


  // ****RoleManagement ends********* 

  // *******Member Profile starts*******

  // Application and Roles start
  userAppRoleMapping(userAppRoleMapping: any): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(this.userAppRoleMap, userAppRoleMapping)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('userAppRoleMapping', null))
      );
  }
  deleteAppWithRoles(obj: any): Observable<any> {
    this.deleteOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Anonymous': 'yes' }),
      body: obj
    };

    return this.httpClient.delete<any>(this.appRoleDelete, this.deleteOptions)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('deleteAppWithRoles', null))
      );
  }

  getUserAppRoleMapping(userID: any): Observable<any> {
    return this.httpClient.get<any>(this.getUserAppRoleMap + `${userID}`)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('getUserAppRoleMapping', null))
      );
  }

  // Member Profile Change Password
  changeUserPassword(changePassword: any): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(this.changePassword, changePassword)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('changeUserPassword', null))
      );
  }

  getNationalStaff(): Observable<any> {
    return this.httpClient.get<any>(this.getNationalUsers)
      .pipe(
        catchError(this.handleError<any>('getNationalStaff', null))
      );
  }

  // Generic Roles , Application and Roles Post
  rolesAssign(roleAssign: any): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(this.userRoleAssign, roleAssign)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('rolesAssign', null))
      );
  }

  updateRolesAssigned(roleAssign: any): Observable<ApiResponse> {
    return this.httpClient.put<ApiResponse>(this.userRoleAssign, roleAssign)
      .pipe(
        retry(1),
        catchError(this.handleError<ApiResponse>('updateRolesAssigned', null))
      );
  }
  getAssignedGenericRoles(UserId: any): Observable<any> {
    return this.httpClient.get<any>(this.getUserGenericRoles + `${UserId}`, this.httpOptions)
      .pipe(
        catchError(this.handleError<any>('getAssignedGenericRoles', null))
      );
  }

  // ********Member Profile - Application and Roles Ends**********

  changeOrganization(userInfo: any): Observable<any> {
    return this.httpClient.post<any>(this.changeOrg, userInfo, this.httpOptions)
      .pipe(
        retry(1),
        catchError((err) => throwError(() => err))
      );
  }

  deleteOrganization(deleteOrg: any) {
    return this.httpClient.post<any>(this.deleteOrg , this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError<any>('deleteOrganization', null))
      );
  }
}


